import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { generalStore } from "store/generalStore";
import CircularLoader from "../CircularLoader";

const ConfirmationModal = ({ onDelete, id, isLoading, message, type }) => {
  const deleteModalOpen = generalStore((state) => state.deleteModalOpen);
  const setDeleteModalOpen = generalStore((state) => state.setDeleteModalOpen);

  return (
    <div>
      {/* <Button onClick={handleOpen} variant="contained" className="bs-btn">
        <span className="text">Confirmation Modal </span>
      </Button> */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={deleteModalOpen}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="bs-modal typ-confirmation-modal"
      >
        <Fade in={deleteModalOpen}>
          <div className="modal-cont">
            <div className="modal-header">
              <IconButton
                className="bs-btn btn-icon"
                disableRipple
                onClick={() => setDeleteModalOpen(false)}
              >
                <span className="icon icon-close"></span>
              </IconButton>
            </div>
            <div className="modal-body">
              <h3 className="title">
                {message ? message : "Are you sure you want to delete?"}
              </h3>
              <div className="action-wrap">
                <Button
                  variant="contained"
                  className="bs-btn btn-border"
                  onClick={() => setDeleteModalOpen(false)}
                >
                  <span className="text">No</span>
                </Button>
                <Button
                  variant="contained"
                  className="bs-btn"
                  onClick={() => onDelete(id, type)}
                  disabled={isLoading ? true : false}
                  endIcon={
                    isLoading ? (
                      <CircularLoader loaderClr={"var(--white)"} />
                    ) : (
                      ""
                    )
                  }
                >
                  <span className="text">Yes</span>
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
